/**
 * Year count for CART_CHECKOUT.YEAR_UNLIMITED_MILEAGE from planTerms.yearsMileage
 * (e.g. "2 YEARS, 999,999 MILES" or "24 MONTHS").
 */
export function lamboUnlimitedTermYear(yearsMileage: string | undefined | null): string {
  if (!yearsMileage || !String(yearsMileage).trim()) {
    return '1';
  }
  const s = String(yearsMileage);
  const yearMatch = s.match(/(\d+)\s*(?:YEAR|YEARS|YEAR\(S\))/i);
  if (yearMatch) {
    return String(parseInt(yearMatch[1], 10));
  }
  const monthMatch = s.match(/(\d+)\s*MONTHS?/i);
  if (monthMatch) {
    const months = parseInt(monthMatch[1], 10);
    const years = months / 12;
    if (years >= 1 && Number.isInteger(years)) {
      return String(years);
    }
    return String(Math.max(1, Math.round(months / 12)));
  }
  const first = s.trim().split(/\s+/)[0];
  if (/^\d+$/.test(first)) {
    return first;
  }
  return '1';
}
